/* eslint-disable react/prop-types */
import { HeaderNavigation as CarbonHeaderNavigation } from '@carbon/react';

export const HeaderNavigation = ({ children, ...props }) => (
  <CarbonHeaderNavigation {...props}>{children}</CarbonHeaderNavigation>
);
